const getBaseUrl = () => {
    const baseHostName = window.location.hostname;
  
    if (baseHostName.includes("localhost")) {
      return {
        REG :"https://registration-service-staging.tradeboss.co",
        ADMIN:"https://admin-backend-staging.tradeboss.co"
      }; // Local
    }
  
    if (baseHostName.includes("staging")) {
      return {
        REG: "https://registration-service-staging.tradeboss.co",
        ADMIN: "https://admin-backend-staging.tradeboss.co"
      } // Staging
    }
  
    return {
      REG: "https://registration-service.tradeboss.co",
      ADMIN: "https://admin-backend.tradeboss.co"
    } // Production
  };
  
  const BASE_URL = getBaseUrl();
  
export {BASE_URL};
  